import { deepAnalysisApi } from '../service';
import { UrlCluster, FetchUrlClustersParams } from './types';


const urlClustersApi = deepAnalysisApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchUrlClusters: builder.query<UrlCluster[], FetchUrlClustersParams>({
            query: (args) => {
                const { w_guid } = args;

                return {
                    method: 'GET',
                    url: `/url-cluster/${w_guid}`
                };
            },

            providesTags: (result, error, args) => [{ type: 'UrlClusters', id: args.w_guid }],
        })
    })
});

export const {
    useFetchUrlClustersQuery
} = urlClustersApi;
